import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Link,
    useLoaderData,
    useNavigate
  } from "react-router-dom";
import { Button, Card, Table, Pagination, Input, Alert, Dropdown } from 'react-daisyui'
import Survey from '../../interfaces/surveys';
import { LoaderData } from '../../types/LoaderData';
import Study from '../../interfaces/study';
import {TaskResponse, TaskStatuses, TaskPollingStatuses, StudyFlags, Task, TASKS, PollingStudyFlagsAndTask} from '../../interfaces/Task'
import APIData from '../../interfaces/apiData';
import { CheckIcon } from '@heroicons/react/24/outline'
import PaginationBar from '../../components/PaginationBar';
import Search from './search';
import StudyTable from './components/StudyTable';
import debounce from 'lodash.debounce';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorToast from './components/ErrorToast';

import ExportConfirmationModal from './components/ExportConfirmationModal';
import ExportMultiStudyResponsesCSVModal from './components/ExportMultiStudyResponsesCSVModal';
import ActivateStudyConfirmModal from './components/ActivateStudyConfirmModal';
import { escapeRegExp } from '../../utils/escapeReg';
import { axiosFileDownload } from '../../utils/axiosFileDownload';
import ExportResponsesSPSSModal from './components/ExportResponsesSPSS';

export async function loader({request}: any) {

  // Get page param from search params
  const url = new URL(request.url);
  const isPage = url.searchParams.get("page");
  const isPageSize = url.searchParams.get("page_size");
  const filter = url.searchParams.get("title");
  const orderBy = url.searchParams.get("order_by") || "-created_at"; //Set "-created_at" to default, also need to set the orderBy state. 
  const startDate = url.searchParams.get("created_at_after");
  const endDate = url.searchParams.get("created_at_before");
  const active = url.searchParams.get("active")
  const measuregroup = url.searchParams.get("measuregroup")

  // default of page 1 if no page parameter
  const page = isPage ? parseInt(isPage) : 1;
  const pageSize = isPageSize ? parseInt(isPageSize) : 10;

  // Form the parameters for the axios request.
  const params = {
    page_size: pageSize,
    page: page,
    title: filter,
    order_by: orderBy,
    created_at_after: startDate,
    created_at_before: endDate,
    active: active,
    measuregroup: measuregroup
  };
  console.log(`/api/v1/study/`, { params })
  const studies: APIData = await (await axios.get(`/api/v1/study/`, { params })).data;
  const activatedStudies = studies.results.filter((study: Study) => study.active).map((study: Study) => study.id);
  const measureGroups = await (await axios.get('/api/v1/measure-group/')).data.results;
  const celery_time_limit = await (await axios.get('/api/v1/study/celery_time_limit/')).data.celery_task_time_limit;
  console.log(celery_time_limit)
  return {studies, page, pageSize, filter, orderBy, startDate, endDate, activatedStudies, measureGroups, celery_time_limit};
}

export default function Index() {

  // If its relevent in the future for what were doing with Lo
  const navigate = useNavigate();
  const {studies, activatedStudies, page, measureGroups, celery_time_limit} = useLoaderData() as LoaderData<typeof loader>; 
  const [pageSize, setPageSize] = useState<string>("10");
  const [activeFilter, setActiveFilter] = useState('');
  const [measureGroupFilter, setMeasureGroupFilter] = useState('');
  const [filter, setFilter] = useState<string>('');
  const [orderBy, setOrderBy] = useState<string>('-created_at');
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const [selectedStudies, setSelectedStudies] = useState<Set<number>>(new Set());
  const [isAllStudiesSelected, setIsAllStudiesSelected] = useState<boolean>(false);
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);

  const [activateList, setActivateList] = useState([] as number[]);
  const [activateStudyId, setActivateStudyId] = useState<number>(0);  

  const [taskStatuses, setTaskStatuses] = useState<TaskStatuses>({});
  const [taskPollingStatuses, setTaskPollingStatuses] = useState<TaskPollingStatuses>({});
  
  useEffect(() => {
    //Initialize the activateList from the loader
    setActivateList(activatedStudies);
  }, [])

  useEffect(() => {
    //Resume the polling update status for the tasks that are still in progress whenever the table component get initialized.
    const intervalIds: any = []; // Store interval IDs in an array
  
    for (let study of studies.results) {
      if (study?.created && !study?.active && study?.task?.status !== 'SUCCESS') {        
        // Schedule a GET request every 1 second and store the interval ID in the array
        const intervalId = pollingStudyFlagsForTaskStatus(study.id);
        intervalIds.push(intervalId);
      }
    }
  
    // Cleanup function to clear all the intervals when the component unmounts
    return () => {
      intervalIds.forEach((intervalId: any) => {
        clearInterval(intervalId);
      });
    };
  }, [studies]);

  const handleActivateButtonClick = async(studyId: number) => {
    
    //Get study id when activate button is clicked
     //Open the modal
    setActivateStudyId(studyId);  
    setIsActivateModalOpen(true);
  };

  const updateActiveList = async() => {
    const studies: APIData = await (await axios.get(`/api/v1/study/`)).data;
    const newActivatedStudies = studies.results.filter((study: Study) => study.active).map((study: Study) => study.id);
    console.log(newActivatedStudies)
    setActivateList(newActivatedStudies);
  }

  const handleStudyActivation = async() => {

    const executeTask = () => {

      axios.get(`api/v1/study/${activateStudyId}/study_activation_tasks_action/`)
        .then(response => {
          const intervalId = pollingStudyFlagsForTaskStatus(activateStudyId)
        })
        .catch(error => console.log(error));
    };
  
    executeTask();
    console.log(taskStatuses)
  };


const pollingStudyFlagsForTaskStatus = (activateStudyId: number) => {
    const startTime = Date.now();  // Store the start time

    const intervalId = setInterval(async () => {
        try {
            const elapsedTime = Date.now() - startTime;
            // If elapsed time exceeds the time limit, stop polling
            if (elapsedTime > celery_time_limit * 1000 + 60*1000*2 ) { //celery time limit set in backend and convert to milliseconds here, add extra 2 minutes. If the backend didn't capture the timelimitexceed, this will serve as the final safe guard to stop the polling for this study.  
              clearInterval(intervalId);
              console.error('Polling time limit exceeded');
              updateTaskPollingStatuses("TimeLimitExceeded: Frontend polling time limit exceeded. Please contact the development team for this issue.", activateStudyId);
              toast.error(`Polling for Study ID: ${activateStudyId} exceeded time limit.`, {
                autoClose: 30000,
              });
              return;
          }

            const taskResponse: TaskResponse = await getTaskResponse(activateStudyId)
            const {data} = await axios.get(`/api/v1/study/${activateStudyId}/`);
            const studyData: PollingStudyFlagsAndTask = {
                active: data.active,
                created: data.created,
                properties: data.properties,
                questions: data.questions,
                demographics: data.demographics,
                intro_consent: data.intro_consent,
                base: data.base,
                constant: data.constant,
                task: data.task,
            };
          
            const { task: studyTask } = studyData; //Destructure and assign task data to new variable studyTask
            updateTaskPollingStatuses("", activateStudyId);

            if (isTaskFailure(studyTask)) {
              clearInterval(intervalId);
              updateTaskStatuses(studyData, activateStudyId);
              updateTaskPollingStatuses("", activateStudyId);
          } 

            if (studyData.active === true && taskResponse.status === 'SUCCESS' && studyTask?.status === 'SUCCESS') {
              console.log('POLLING alltrue',  intervalId)
                updateTaskStatuses(studyData, activateStudyId);
                updateTaskPollingStatuses("", activateStudyId);
                clearInterval(intervalId);
                endPolling();
                toast.success(`Study ID: ${activateStudyId} is successfully activated.`, {
                  autoClose: 30000,
                });
            }

            updateTaskStatuses(studyData, activateStudyId);
            // updateTaskPollingStatuses("", activateStudyId);
        } catch (error: any) {
            console.error('Error during polling: ', error);
            updateTaskPollingStatuses(`Error during polling: ${error.response.data}`, activateStudyId);
            clearInterval(intervalId);
        }
    }, 5000);

    console.log('intervalID', activateStudyId, intervalId);
    return intervalId;
};

const getTaskResponse = async(activateStudyId: number) => {
  //Get the updated Celery task response with the target study id
  const response = await axios.get(`api/v1/study/${activateStudyId}/get_task_status/`);
  console.log(response.data)
  return response.data
}

// useEffect(() => {
//   console.log("Updated taskStatuses:", taskStatuses);
// }, [taskStatuses]);

const isTaskFailure = (studyTask: TaskResponse | null): boolean => {
    return studyTask?.status != null && studyTask.status === 'FAILURE';
};

const endPolling = (): void => {
    console.log('All Flags are true!');
    setIsActivateModalOpen(false);
    updateActiveList();
    
};

const updateTaskStatuses = (studyData: any, activateStudyId: number): void => {
  setTaskStatuses(prevStatuses => ({
      ...prevStatuses,
      [activateStudyId]: studyData
  }));
};

const updateTaskPollingStatuses = (apiMessage: any, activateStudyId: number): void => {
  setTaskPollingStatuses(prevStatuses => ({
      ...prevStatuses,
      [activateStudyId]: apiMessage
  }));
};

/** END - To be extract out to a single file, functions and interface for pollingStudyFlagsForTaskStatus */

  useEffect(()=>{
    /** Reset all checked boxes when filters are applied */
    setSelectedStudies(new Set());
  }, [filter, startDate, endDate])

  /** Checkboxes functions */
  const toggleStudySelection = (id: number) => {
    const newSelectedStudies = new Set(selectedStudies);
    if (selectedStudies.has(id)) {
      newSelectedStudies.delete(id);
    } else {
      newSelectedStudies.add(id);
    }
    setSelectedStudies(newSelectedStudies);
  };

  const selectAllStudies = () => {
    const newSelectedStudies = new Set(selectedStudies);
    if (isAllStudiesSelected) {
        // if all studies are selected, deselect all ON CURRENT PAGE
        for (const study of studies?.results) {
          newSelectedStudies.delete(study.id);
        }
    } else {
        // if not all studies are selected, select all ON CURRENT PAGE
        for (const study of studies?.results) {
          newSelectedStudies.add(study.id);
        }
    }
    setSelectedStudies(newSelectedStudies);
  }

  useEffect(() => {
    // Determine if all studies on the current page are selected
    const allStudiesSelected = studies?.results.every(study => selectedStudies.has(study.id));
    setIsAllStudiesSelected(allStudiesSelected);
  }, [studies, selectedStudies]);

  /** End of Checkboxes functions */

  const navigateWithParams = (params: { page?: number, pageSize?: string, filter?: string, orderBy?: string, startDate?: Date | null, endDate?: Date | null, active?: string, measuregroup?: string }) => {
    const paramsStartDate: string = params.startDate ? moment(params.startDate).format('YYYY-MM-DD') : '';
    const paramsEndDate: string = params.endDate ?  moment(params.endDate).format('YYYY-MM-DD') : '';
    
    const urlParams = new URLSearchParams({
      page: (params.page || page).toString(),
      page_size: params.pageSize || pageSize,
      title: params.filter || filter,
      order_by: params.orderBy || orderBy,
      created_at_after: paramsStartDate ? paramsStartDate : "",
      created_at_before: paramsEndDate ? paramsEndDate : "",
      active: params.active || activeFilter,
      measuregroup: params.measuregroup || measureGroupFilter
    });
    
    navigate(`/studies?${urlParams.toString()}`);
  };
  
  // Change the current page of the paginated data
  function changePage(number: number){
    navigateWithParams({ page: number });
  }

  function changePageSize(size: string) {
    const totalPages = Math.ceil(studies.total / parseInt(size));

    // If the current page is greater than the total pages calculated by the new page size, 
    // reset the page to the last available page.
    let newPage = page > totalPages ? totalPages : page;

    setPageSize(size);
    navigateWithParams({ pageSize: size, page: newPage });
  }

  function changeActiveFilter(activeFilter: any){
    setActiveFilter(activeFilter)
    navigateWithParams({ active: activeFilter });
  }

  function changeMeasureGroupFilter(measureGroupFilter: any){
    setMeasureGroupFilter(measureGroupFilter)
    navigateWithParams({ measuregroup: measureGroupFilter });
  }
  

  /** Search title functions */
  // Create debounced version of the search
  useEffect(() => {
    const searchTitle = debounce(async () => {
        if (filter) {
          const escapedFilter = escapeRegExp(filter);
          navigateWithParams({ filter: escapedFilter });
        } else {
          navigateWithParams({ filter: "" });
        }
    }, 1000);  // 1000ms delay

    searchTitle();

    // Cleanup
    return () => {
      searchTitle.cancel();
    };
  }, [filter]);

  function changeFilter(newFilter: string){
    setFilter(newFilter);
  }
  /** End of Search title functions */

  function changeOrderBy(newOrderBy: string){
    setOrderBy(newOrderBy);
    navigateWithParams({ orderBy: newOrderBy });
  }

  function validDate(newDate: Date): boolean {
    const dateString: string = moment(newDate).format('YYYY-MM-DD');
    const isDateValid: boolean = moment(dateString, 'YYYY-MM-DD', true).isValid();
  
    return isDateValid;
  }

  function changeStartDate(newDate: Date) {
    if(validDate(newDate) === false) { //reset all dates if input date is invalid
      setStartDate(null);
      setEndDate(null);
      navigateWithParams({ page: 1, startDate: null, endDate: null });
      return ;
    } 

    setStartDate(newDate);
    navigateWithParams({ page: 1, startDate: newDate, endDate: endDate });
  }
  
  function changeEndDate(newDate: Date) { //reset all dates if input date is invalid
    if(validDate(newDate) === false) { 
      setStartDate(null);
      setEndDate(null);
      navigateWithParams({ page: 1, startDate: null, endDate: null });
      return ;
    } 

    setEndDate(newDate);
    navigateWithParams({  page: 1, startDate: startDate, endDate: newDate });
  }

  // Reset all parameters to their defaults
  function resetParams() {
    setPageSize("10");
    setFilter('');
    setOrderBy('');
    setStartDate(null);
    setEndDate(null);
    navigate(`/studies`);
    setSelectedStudies(new Set());
  }

   /* Export studies functions */
   const [isExportModalOpen, setIsExportModalOpen] = useState(false);
   const [isExportStudyResponsesSPSSOpen, setIsExportStudyResponsesSPSSOpen] = useState(false);
 
 
   const openExportModal = () => setIsExportModalOpen(true);
   const openExportStudyResponsesSPSSOpen = () => setIsExportStudyResponsesSPSSOpen(true);
   const closeExportModal = () => setIsExportModalOpen(false);
 
   const startPolling = (
     taskId: string,
     onSuccessMessage = 'Report generation complete! Downloading...',
     onFailureMessage = 'Report generation failed. Check logs for more details.',
     closeModal: () => void
   ) => {
     const intervalId = setInterval(async () => {
       const taskStatus = await pollTaskStatus(taskId); // Function to poll the task status
       if (taskStatus === 'SUCCESS') {
         clearInterval(intervalId);
         toast.success(onSuccessMessage);
         downloadSPSSData(taskId);
         closeModal(); // Handle modal close logic
       } else if (taskStatus === 'FAILURE') {
         clearInterval(intervalId);
         toast.error(onFailureMessage);
       }
     }, 5000); // Poll every 5 seconds
   };
 
   const pollTaskStatus = async (taskId: string) => {
     try {
       const response = await axios.get(`/api/v1/task/check_task_status/`, {
         params: { id: taskId },
       });
       return response.data.status; // Return task status: 'SUCCESS', 'FAILURE', or 'PENDING'
     } catch (error) {
       console.error('Error polling task status:', error);
       return 'FAILURE';
     }
   };
 
   /**
  * Downloads a report (individual or cohort) based on the task ID.
  * Handles fetching the pre-signed URL, downloading the file, and triggering the browser download.
  *
  * @param taskId - The ID of the task for the report generation.
  * @param reportType - The type of the report, 'individual' or 'cohort'.
  */
   const downloadSPSSData = async (taskId: string) => {
     try {
       // Get the pre-signed URL
       const response = await axios.get(`/api/v1/download_spss_data`, {
         params: { id: taskId },
       });
 
       if (response.status !== 200 || !response.data.url) {
         throw new Error('Failed to retrieve the download URL.');
       }
 
       const fileUrl = response.data.url;
 
       // Download the file using the pre-signed URL
       const fileResponse = await axiosFileDownload.get(fileUrl, { responseType: 'arraybuffer' });
 
       // Create a downloadable link and trigger the download
       const blob = new Blob([fileResponse.data]);
       const url = window.URL.createObjectURL(blob);
       const link = document.createElement('a');
       link.href = url;
 
       // Set the filename dynamically based on the report type
       const fileName = 'all_selected_studies_spss_responses.zip';
       link.setAttribute('download', fileName);
 
       document.body.appendChild(link);
       link.click();
       link.remove();
     } catch (error: any) {
       // Handle errors
       const errorMessage = error?.response?.data || `Error downloading SPSS data`;
       toast.error(errorMessage);
     }
   };
 
   const exportStudyResponsesSPSS = (status: string) => {
 
     const ids = Array.from(selectedStudies);
 
     if (ids.length === 0) {
       toast.error("Please select at least one study before exporting.", {
         autoClose: 3000,
       });
       setIsExportStudyResponsesSPSSOpen(false)
       return; // Exit the function without making the API call
     }
     console.log(status)
     return axios.post(`/api/v1/export_study_spss_responses`, { status: status, study_ids: ids })
       .then(response => {
         const taskId = response.data.task_id;
         if (!taskId) {
           throw new Error('Task ID not returned by the server');
         }
         return taskId;
       })
       .catch(e => {
         toast.error(`Error exporting SPSS files - ${e?.response.data}`)
       })
   }

  const exportSelectedStudies = (options: any) => {
   
    const ids = Array.from(selectedStudies);
    
    if (ids.length === 0) {
        toast.error("Please select at least one study before exporting.", {
          autoClose: 3000, 
        });
        closeExportModal();
        return; // Exit the function without making the API call
    }

    const requestBody = {
      ids: ids,
      sort_by_date: options.sort_by_date,
      selected_option: options.selected_option
    };
    console.log('Exporting selected studies:', requestBody);
    
    axios.post('/api/v1/export_study_responses', requestBody)
      .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `studies_responses.csv`);
          document.body.appendChild(link);
          link.click();
      })
      .catch(error => {
        console.error("Error fetching data:", error.response.data);
        toast.error(error.response.data, {
          autoClose: 30000,
        });
      });
    
    // Close the modal when done
    closeExportModal();
  };
  /* End of Export studies functions */
  
  interface TaskStatusProps {
    activateStudyId: number;
    taskStatuses: TaskStatuses;
    study: any
    taskPollingStatusMessage: '' | undefined;
  }

  const TaskStatus: React.FC<TaskStatusProps> = ({ activateStudyId, taskStatuses, study, taskPollingStatusMessage }) => {
    const liveStatus = taskStatuses[activateStudyId]
    const taskResponse: any = taskStatuses[activateStudyId] ? taskStatuses[activateStudyId]?.task : study?.task
    const taskId = taskResponse?.task_id
    const taskStatus = taskResponse?.status
    const taskResult = taskResponse?.result
    //const taskStatus = status?.task;
    const hasTimeLimitExceededError = taskResult?.toLowerCase().includes("timelimitexceeded");
    
    return (
      <>
       {console.log('taskPollingStatusMessage', taskPollingStatusMessage)}
        {liveStatus && (
                <ul className="min-width-l">
                    {TASKS.map((task) => (
                        <li className="mb-2" key={task.name}>
                            <p className={`Task ID: ${liveStatus[task.study_object_key] ? 'text-success' : ''}`}>
                                {`${task.name}: ${liveStatus[task.study_object_key] ? 'success' : 'processing...'}`}
                            </p>
                        </li>
                    ))}
                </ul>
            )}
        {taskStatus === 'FAILURE' && (
        <Alert status="error" className="mb-2" icon={<svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>}>
          <span><strong>Task ID:</strong> {taskId} <br /> 
          {hasTimeLimitExceededError 
            ? <><strong>Error:</strong> {taskResult}<p><strong>Please call the development team for this issue.</strong></p></>
            : <><strong>Error:</strong> {taskResult}</>}
          </span>
        </Alert>
      )}
      {taskPollingStatusMessage !== '' &&  taskPollingStatusMessage !== undefined && (
        <Alert status="error" icon={<svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>}>
          <span> 
          <><strong>{taskPollingStatusMessage}</strong></>
          </span>
        </Alert>
      )}
      </>
    );
  };
  
  

  return (
    <div className="overflow-x-auto">
      <div className="flex flex-row items-center mb-5">
        <h1 className="text-3xl font-bold flex-1">Study List</h1>
        <Dropdown end={true} className="mr-4">
            <Dropdown.Toggle color="neutral"  button={true} className="w-72" id="StudyExportDropdownButton">Export Selected Studies</Dropdown.Toggle>
            <Dropdown.Menu className="w-60 z-10">
            <Button onClick={openExportModal} id="ExportSelectedStudyButton" color="ghost">
              CSV       
            </Button>
            <Button onClick={openExportStudyResponsesSPSSOpen} id="ExportSPSSSelectedStudyButton" color="ghost">
              SPSS
            </Button>
            </Dropdown.Menu>
          </Dropdown>
        {/* <Button onClick={openExportModal} id="ExportAllStudiesButton" className="mr-4 btn-neutral">
          Export All Studies
        </Button> */}
        <Link className='btn btn-primary hover' id="AddStudyButton" to={`/studies/create`}>Add Study</Link>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-8 md:grid-cols-5 gap-4 w-full mb-4">
    <div className='w-full'>
        <label className="label">
            <span className="label-text text-sm">Search title</span>
        </label>
        <Input
          type="text"
          id="SearchTitleFilterInput"
          value={filter}
          onChange={(e) => changeFilter(e.target.value)}
          placeholder="Type to search title"
          className="p-2 w-full"
        />
    </div>
    <div className='w-full'>
        <label className="label">
            <span className="label-text text-sm">Start date</span>
        </label>
        <DatePicker
            selected={startDate}
            id="StartDateFilterInput"
            onChange={(date: Date) => changeStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={endDate}
            dateFormat="yyyy-MM-dd"
            placeholderText="YYYY-MM-DD"
            className="input input-bordered focus:outline-offset-0 p-2 text-sm w-full"
        />
    </div>
    <div>
        <label className="label">
            <span className="label-text text-sm">End date</span>
        </label>
        <DatePicker
            selected={endDate}
            id="EndDateFilterInput"
            onChange={(date: Date) => changeEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            dateFormat="yyyy-MM-dd"
            placeholderText="YYYY-MM-DD"
            className="input input-bordered focus:outline-offset-0 p-2 text-sm w-full"
        />
    </div>
    <div>
        <label className="label">
            <span className="label-text text-sm">Order by</span>
        </label>
        <select
            className="select select-bordered focus:outline-offset-0 text-xs w-full"
            id="OrderByFilterInput"
            value={orderBy}
            onChange={(e) => changeOrderBy(e.target.value)}
        >
            <option disabled selected>
                Order by
            </option>
            <option id="OrderByFilterInputOption1" value="title">Title - ASC</option>
            <option id="OrderByFilterInputOption2" value="-title">Title - DESC</option>
            <option id="OrderByFilterInputOption3" value="created_at">Created at - ASC</option>
            <option id="OrderByFilterInputOption4" value="-created_at" selected>Created at - DESC</option>
            <option id="OrderByFilterInputOption5" value="active">Inactive study</option>
            <option id="OrderByFilterInputOption6" value="-active">Active study</option>
        </select>
    </div>
    <button onClick={resetParams} id="ResetFiltersButton" className="btn btn-accent mt-auto xl:col-start-8 xl:col-span-1">
        Reset
    </button>
</div>

      <ActivateStudyConfirmModal 
        isOpen={isActivateModalOpen}
        closeModal={() => {setIsActivateModalOpen(false);}}
        handleStudyActivation={handleStudyActivation}
        content={
          <TaskStatus activateStudyId={activateStudyId} taskStatuses={taskStatuses} study={studies.results.find((study: any) => study.id === activateStudyId)} taskPollingStatusMessage={taskPollingStatuses[activateStudyId]} />
        }
        studies={studies.results} 
        taskStatueses={taskStatuses}
        activateStudyId={activateStudyId}
        error={taskStatuses[activateStudyId]?.task?.status === 'FAILURE' || studies.results.find((study: any) => study.id === activateStudyId)?.task?.status === 'FAILURE'}
        timeLimitExceeded={taskStatuses[activateStudyId]?.task?.result.toLowerCase().includes("timelimitexceeded") || taskPollingStatuses[activateStudyId]?.toLowerCase().includes("timelimitexceeded") }
        taskPollingStatus = {taskPollingStatuses[activateStudyId] !== '' && taskPollingStatuses[activateStudyId] !== undefined}
      />
      {/* <ExportConfirmationModal
        isOpen={isExportModalOpen}
        onClose={closeExportModal}
        onExport={exportSelectedStudies}
        selectedData={selectedStudies}
      /> */}
      <ExportMultiStudyResponsesCSVModal
        isOpen={isExportModalOpen}
        onClose={closeExportModal}
        onAction={exportSelectedStudies}
        title = "Export Study Responses CSV"
      />
      <ExportResponsesSPSSModal
              isOpen={isExportStudyResponsesSPSSOpen}
              onClose={() => setIsExportStudyResponsesSPSSOpen(false)}
              onAction={(status: string) => exportStudyResponsesSPSS(status)?.then(taskId => {
                          if (taskId) {
                            startPolling(
                              taskId,
                              'SPSS Data generation complete! Downloading...',
                              'SPSS Data generation failed. Check logs for more details.',
                              () => setIsExportStudyResponsesSPSSOpen(false) 
                            );
                            
                          } else {
                            toast.error('Failed to initiate SPSS Data generation.');
                            setIsExportStudyResponsesSPSSOpen(false) 
                          }
                        })}
              title="Export Study Responses SPSS"
              showInfoAlert="Generating SPSS file. Please wait..."
        />
      {studies?.total ? (
        <>
          <p className='ml-2 mb-2'>{selectedStudies?.size ? `${selectedStudies.size} item${selectedStudies.size > 1 ? 's' : ''} selected` : '0 item selected'}</p>
          <StudyTable
            studies={studies?.results}
            navigateToStudy={(id) => navigate(`/studies/${id}`)}
            navigateToEditStudy={(id) => navigate(`/studies/edit/${id}`)}
            filter={filter}
            selectedStudies={selectedStudies}
            toggleStudySelection={toggleStudySelection}
            onActivateButtonClick={handleActivateButtonClick}
            selectAllStudies={selectAllStudies}
            isAllStudiesSelected={isAllStudiesSelected}
            activateList={activateList}
            taskStatuses={taskStatuses}
            taskPollingStatus={taskPollingStatuses}
          />

          
        </>
      ) : (
        <p className='m-4 pt-4 pb-4'>
          <i>No Studies Found</i>
        </p>
      )}
      <div className="flex justify-between mt-2">
            <div>
              <select
                value={pageSize}
                id="PageSizeSelectInput"
                onChange={(e) => changePageSize(e.target.value)}
                className=" select select-bordered focus:outline-offset-0"
              >
                <option id="PageSizeSelectInputOption1" value="10">10</option>
                <option id="PageSizeSelectInputOption2" value="20">20</option>
                <option id="PageSizeSelectInputOption3" value="50">50</option>
                <option id="PageSizeSelectInputOption4" value="100">100</option>
              </select>

              <select
                id="ActiveStudySelectInput"
                className="select select-bordered focus:outline-offset-0 ml-2"
                value={activeFilter}
                onChange={e => changeActiveFilter(e.target.value)}
              >
                <option id="ActiveStudySelectInputOption1" value="all">Show all studies</option>
                <option id="ActiveStudySelectInputOption2" value="true">Active</option>
                <option id="ActiveStudySelectInputOption3" value="false">Inactive</option>
              </select>

              <select
                  id="MeasureGroupSelectInput"
                  className="select select-bordered focus:outline-offset-0 ml-2"
                  value={measureGroupFilter}
                  onChange={e => changeMeasureGroupFilter(e.target.value)}
              >
                <option value="">Select a Measure Group</option>
                  {measureGroups.map((mg: any) => (
                      <option key={mg.id} value={mg.id}>
                          {mg.title}
                      </option>
                  ))}
              </select>

            </div>
            <PaginationBar
              onChange={changePage}
              itemCount={studies.total}
              currentPage={studies.current_page}
              pageSize={studies.page_size}
            ></PaginationBar>
          </div>
      <ToastContainer /> {/* Add this to the root of your application */}
    </div>
  );
}
